import React, { useState, useEffect } from 'react';
import PostbackForm from 'modules/PostbacksModule/components/PostbackForm';
import { snackbar } from 'components/notifications/notifications';
import ninjaApi from 'store/redux/apis';
import useQueryParams from 'hooks/useQueryParams';
import { useUpdatePostbackMutation } from 'modules/PostbacksModule/api/postbacks.api';
import AutomaticDrawer from 'components/Drawers/AutomaticDrawer';
import PostbackCampaignSpent from 'modules/PostbacksModule/components/PostbackCampaignSpent/PostbackCampaignSpent';
import { Tabs } from 'antd';

const UpdateRecievePostbackDrawer = (props) => {
  const { removeParams, searchParams } = useQueryParams();
  const { postback_id } = searchParams;
  const [postback, setPostback] = useState([]);
  const [fields, setFields] = useState(null);

  // Fetch single postback query from rtk
  const [fetchPostback, { isLoading: fetchLoading, isUninitialized, data }] =
    ninjaApi.useLazyGetPostbackQuery();
  // Call update postback mutation hook from rtk
  const [updatePostback, { isLoading: updateLoading }] = useUpdatePostbackMutation();
  const [getPostbacksQuery, { isFetching, data: list = [] }] = ninjaApi.useLazyListPostbacksQuery();

  const loading = fetchLoading || updateLoading;

  useEffect(() => {
    const ids = postback_id !== 'all' ? postback_id.split(',').map((id) => parseInt(id, 10)) : [];
    if (postback_id !== 'all') {
      fetchPostback(ids)
        .unwrap()
        .then((pb) => {
          setPostback(pb?.data);
          setFields(pb.fields);
        });
    } else {
      getPostbacksQuery({ per_page: 1000 })
        .unwrap()
        .then((data) => setPostback(data?.data));
    }
  }, [postback_id]);

  const onSubmit = (data) => {
    data.id = postback_id;
    updatePostback(data)
      .unwrap()
      .then((pb) => {
        setPostback(pb);
        removeParams(['edit', 'postback_id']);
        snackbar.success(`${pb.name} postback updated successfully`);
      });
  };

  if (fetchLoading) {
    return null;
  }

  const items = [
    data?.data?.length <= 1 &&
      postback_id !== 'all' && {
        key: 'Update',
        label: 'Update Postback',
        show: false,
        children: (
          <PostbackForm
            fields={fields}
            editing={true}
            loading={loading}
            onSubmit={onSubmit}
            initialData={postback[0]}
          />
        ),
      },
    {
      key: 'ad_spent',
      label: 'Exclude Ads & Accounts',
      children: postback.map((d) => (
        <PostbackCampaignSpent id={d.id} data={d} loading={isFetching || loading} />
      )),
    },
  ];

  return (
    <AutomaticDrawer size='large' title='Update Postback' {...props}>
      <Tabs className='text-md font-semibold' defaultActiveKey='Update' items={items} />
    </AutomaticDrawer>
  );
};

UpdateRecievePostbackDrawer.requiredParams = {
  postback_id: (p) => p,
  edit: true,
};

export default UpdateRecievePostbackDrawer;
